export enum QuestionnaireStatus {
  COMPLETED = "completed",
  IN_PROGRESS = "in_progress",
  ERROR = "error",
  NOT_STARTED = "not_started",
  NOT_FOUND = "not_found",
}
